import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import global from "@/common/global.js";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
Vue.config.productionTip = false;
Vue.prototype.$global = global;
Vue.use(ViewUI);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
